// Brand: the game's mark + "from nerdle labs", tagging it as part of the nerdle labs suite of
// research games. Lives in shared/ so every screen (incl. shared ones like BrowserGate /
// StatusScreen) can render the header; each game passes its own `game` so the mark is correct.

export type LabsGame = 'twentyfour' | 'rebus' | 'cryptic'

// The 24 game reads as "24" + "-game"; the word-name games are a single lowercase mark.
const MARKS: Record<LabsGame, { mark: string; suffix?: string }> = {
  twentyfour: { mark: '24', suffix: '-game' },
  rebus: { mark: 'rebus' },
  cryptic: { mark: 'cryptic' },
}

export const Brand = ({ game = 'twentyfour' }: { game?: LabsGame }) => {
  const { mark, suffix } = MARKS[game]
  return (
    <div className="text-center select-none">
      <div className="leading-none">
        <span className="text-3xl font-extrabold text-[#820458]">{mark}</span>
        {suffix && <span className="text-2xl font-semibold text-gray-400">{suffix}</span>}
      </div>
      <div className="mt-1 text-xs text-gray-400">
        from <span className="nerdle-name">nerdle</span> <span className="nerdle-sub-name">labs</span>
      </div>
    </div>
  )
}
